import { Action, createReducer, on } from '@ngrx/store';
import * as action from '../actions';

export const paymentRunTabControlFeatureKey = 'paymentRunTabControl';

export interface PaymentRunTabControlState {
  tabIndex: number;
}

export const initialState: PaymentRunTabControlState = {
  tabIndex: 0
};

export const reducer = createReducer(
  initialState,
  on(action.loadPaymentRunTabControls, (state, action) => ({
    ...state,
    tabIndex: action.tabIndex
  }))
);

export const getPaymentRunTabControlIndex = (state: PaymentRunTabControlState) => state.tabIndex;
